import { mapToConst, mergeTyped } from 'annotation-tools/utils';
import { useEffect } from 'react';
import { Subject } from 'rxjs';
import { auditTime, map, scan, startWith } from 'rxjs/operators';

const openLoadingPageSource = new Subject();
const closeLoadingPageSource = new Subject();
export const openLoadingPage = () => openLoadingPageSource.next();
export const closeLoadingPage = () => closeLoadingPageSource.next();

export const loadingPageIsOpen$ = mergeTyped(
  openLoadingPageSource.pipe(mapToConst(+1)),
  closeLoadingPageSource.pipe(mapToConst(-1))
).pipe(
  scan((acc: number, curr: 1 | -1) => {
    switch (curr) {
      case +1:
        return acc + 1;
      case -1:
        return Math.max(0, acc - 1);
    }
  }, 0),
  map(n => {
    // Log for debugging
    if (n > 0) {
      console.log('Loading counter:', n);
    }
    return n > 0;
  }),
  auditTime(10),
  startWith(false)
);

export const useLoadingPage = (open: boolean) => {
  useEffect(() => {
    switch (open) {
      case true:
        openLoadingPage();
        break;
      case false:
        closeLoadingPage();
        break;
    }
  }, [open]);
};
